var _a;
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./scheduledExport.constants";
export var getPaged = (_a = generateApi(GENERATOR_PARAMS), _a.getPaged), create = _a.create, update = _a.update, remove = _a.remove;
